import { ChangeEvent } from 'react';
import {iProps as TabTitleProps} from '../../shared/tab-navigation/tab-title/TabTitle';

export enum ActionTypes {
  SetActiveSearch = 'setActiveSearch',
  SetReset = 'reset',

  //buildings
  SetBKeywordSearch = 'setBKeywordSearch',
  SetBAvailableSqFtMin = 'setBAvailableSqFtMin',
  SetBAvailableSqFtMax = 'setBAvailableSqFtMax',
  SetBAvailableAcresMin = 'setBAvailableAcresMin',
  SetBAvailableAcresMax = 'setBAvailableAcresMax',
  SetBBuildingTypes = 'setBBuildingTypes',
  SetBSpecialtyFeatures = 'setBSpecialtyFeatures',
  SetBRailServed = 'setBRailServed',
  SetBMultiTenant = 'setBMultiTenant',
  SetBZoning = 'setBZoning',
  SetBReviewStatus = 'setBReviewStatus',
  SetBSaleOrLease = 'setBSaleOrLease',
  SetSSiteCertified = 'setSSiteCertified',
  SetBSortBy = 'setBSortBy',
  SetBStates = 'setBStates',
  SetBRegions = 'setBRegions',
  SetBCounties = 'setBCounties',
  SetBCities = 'setBCities',

  //sites
  SetSKeywordSearch = 'setSKeywordSearch',
  // SetSAvailableSqFtMin = 'setSAvailableSqFtMin',
  // SetSAvailableSqFtMax = 'setSAvailableSqFtMax',
  SetSAvailableAcresMin = 'setSAvailableAcresMin',
  SetSAvailableAcresMax = 'setSAvailableAcresMax',
  SetSSpecialtyFeatures = 'setSSpecialtyFeatures',
  SetSRailServed = 'setSRailServed',
  SetSZoning = 'setSZoning',
  SetSReviewStatus = 'setSReviewStatus',
  SetSSaleOrLease = 'setSSaleOrLease',
  SetSSortBy = 'setSSortBy',
  SetSStates = 'setSStates',
  SetSRegions = 'setSRegions',
  SetSCounties = 'setSCounties',
  SetSCities = 'setSCities',

  SetProperties = 'setProperties',

  SetRadiusCenterPoint = 'setRadiusCenterPoint'
}

export enum SearchTypes {
  Building = 'Buildings',
  Sites = 'Sites',
  Both = 'Both'
}

export interface State {
  activeSearch: SearchTypes;
  selectedTabIndex: number;

  //buildings
  bKeywordSearch: string;
  bAvailableSqFtMin: string;
  bAvailableSqFtMax: string;
  bAvailableAcresMin: string;
  bAvailableAcresMax: string;
  bBuildingTypes: Set<string>;
  bSpecialtyFeatures: Set<string>;
  bRailServed: string;
  bMultiTenant: string;
  bZoning: Set<string>;
  bReviewStatus: Set<string>;
  bSaleOrLease: string;
  bSortBy: string;
  bStates: Set<string>;
  bRegions: Set<string>;
  bCounties: Set<string>;
  bCities: Set<string>;

  //sites
  sKeywordSearch: string;
  // sAvailableSqFtMin: string;
  // sAvailableSqFtMax: string;
  sAvailableAcresMin: string;
  sAvailableAcresMax: string;
  sSpecialtyFeatures: Set<string>;
  sRailServed: string;
  sZoning: Set<string>;
  sReviewStatus: Set<string>;
  sSaleOrLease: string;
  sSiteCertified: string;
  sSortBy: string;
  sStates: Set<string>;
  sRegions: Set<string>;
  sCounties: Set<string>;
  sCities: Set<string>;

  properties: __esri.Graphic[];

  radiusCenterPoint?: __esri.Point;
}

// #region Action Types
type SetActiveSearch = { type: ActionTypes.SetActiveSearch, payload: TabTitleProps };
type SetReset = { type: ActionTypes.SetReset, payload: State };

type SetBKeywordSearch = { type: ActionTypes.SetBKeywordSearch, payload: string };
type SetBAvailableSqFtMin = { type: ActionTypes.SetBAvailableSqFtMin, payload: ChangeEvent<HTMLInputElement> | string };
type SetBAvailableSqFtMax = { type: ActionTypes.SetBAvailableSqFtMax, payload: ChangeEvent<HTMLInputElement> | string };
type SetBAvailableAcresMin = { type: ActionTypes.SetBAvailableAcresMin, payload: ChangeEvent<HTMLInputElement> | string };
type SetBAvailableAcresMax = { type: ActionTypes.SetBAvailableAcresMax, payload: ChangeEvent<HTMLInputElement> | string };
type SetBBuildingTypes = { type: ActionTypes.SetBBuildingTypes, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBSpecialtyFeatures = { type: ActionTypes.SetBSpecialtyFeatures, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBRailServed = { type: ActionTypes.SetBRailServed, payload: string };
type SetBMultiTenant = { type: ActionTypes.SetBMultiTenant, payload: string };
type SetBZoning = { type: ActionTypes.SetBZoning, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBReviewStatus = { type: ActionTypes.SetBReviewStatus, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBSaleOrLease = { type: ActionTypes.SetBSaleOrLease, payload: string };
type SetBSortBy = { type: ActionTypes.SetBSortBy, payload: string };
type SetBStates = { type: ActionTypes.SetBStates, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBRegions = { type: ActionTypes.SetBRegions, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBCounties = { type: ActionTypes.SetBCounties, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetBCities = { type: ActionTypes.SetBCities, payload: ChangeEvent<HTMLInputElement> | Set<string> };

type SetSKeywordSearch = { type: ActionTypes.SetSKeywordSearch, payload: string };
// type SetSAvailableSqFtMin = { type: ActionTypes.SetSAvailableSqFtMin, payload: ChangeEvent<HTMLInputElement> | string };
// type SetSAvailableSqFtMax = { type: ActionTypes.SetSAvailableSqFtMax, payload: ChangeEvent<HTMLInputElement> | string };
type SetSAvailableAcresMin = { type: ActionTypes.SetSAvailableAcresMin, payload: ChangeEvent<HTMLInputElement> | string };
type SetSAvailableAcresMax = { type: ActionTypes.SetSAvailableAcresMax, payload: ChangeEvent<HTMLInputElement> | string };
type SetSSpecialtyFeatures = { type: ActionTypes.SetSSpecialtyFeatures, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSRailServed = { type: ActionTypes.SetSRailServed, payload: string };
type SetSZoning = { type: ActionTypes.SetSZoning, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSReviewStatus = { type: ActionTypes.SetSReviewStatus, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSSaleOrLease = { type: ActionTypes.SetSSaleOrLease, payload: string };
type SetSSiteCertified = { type: ActionTypes.SetSSiteCertified, payload: string };
type SetSSortBy = { type: ActionTypes.SetSSortBy, payload: string };
type SetSStates = { type: ActionTypes.SetSStates, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSRegions = { type: ActionTypes.SetSRegions, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSCounties = { type: ActionTypes.SetSCounties, payload: ChangeEvent<HTMLInputElement> | Set<string> };
type SetSCities = { type: ActionTypes.SetSCities, payload: ChangeEvent<HTMLInputElement> | Set<string> };

type SetProperties = { type: ActionTypes.SetProperties, payload: __esri.Graphic[] };

type SetRadiusCenterPoint = { type: ActionTypes.SetRadiusCenterPoint, payload: __esri.Point | undefined };

//#endregion


// #region Action type
export type Actions = 
  | SetActiveSearch
  | SetReset
  | SetBKeywordSearch
  | SetBAvailableSqFtMin
  | SetBAvailableSqFtMax
  | SetBAvailableAcresMin
  | SetBAvailableAcresMax
  | SetBBuildingTypes
  | SetBSpecialtyFeatures
  | SetBRailServed
  | SetBMultiTenant
  | SetBZoning
  | SetBReviewStatus
  | SetBSaleOrLease
  | SetBSortBy
  | SetBStates
  | SetBRegions
  | SetBCounties
  | SetBCities

  | SetSKeywordSearch
  // | SetSAvailableSqFtMin
  // | SetSAvailableSqFtMax
  | SetSAvailableAcresMin
  | SetSAvailableAcresMax
  | SetSSpecialtyFeatures
  | SetSRailServed
  | SetSZoning
  | SetSReviewStatus
  | SetSSaleOrLease
  | SetSSiteCertified
  | SetSSortBy
  | SetSStates
  | SetSRegions
  | SetSCounties
  | SetSCities

  | SetProperties

  | SetRadiusCenterPoint
;

//#endregion

const initializer = (initialState: State) => initialState;

export function propertyReducer(state: State, action: Actions): State {
  const { type, payload } = action;

  // const selectedStatesLength = state.bStates?.size;
  // const selectedRegionLength = state.bRegions?.size;
  
  const updateSelectedOptions = (options:Set<string>, payload:ChangeEvent<HTMLInputElement>) => {
    
    if(payload.target.checked) {
      options.add(payload.target.value);
    } else {
      options.delete(payload.target.value);
    }

    return options;
  }

  switch(type) {

    case ActionTypes.SetProperties:
      return {
        ...state,
        properties: payload
      };

    case ActionTypes.SetActiveSearch:
      return {
        ...state,
        activeSearch: payload.title as SearchTypes,
        selectedTabIndex: payload.index ?? 0
      };

    case ActionTypes.SetReset:
      const resetState = initializer(payload);
      return {
        ...resetState, 
        activeSearch: state.activeSearch,
        properties: state.properties,
        selectedTabIndex: state.selectedTabIndex
      };
    
    // #region Building Actions
    case ActionTypes.SetBKeywordSearch:
      return {
        ...state,
        bKeywordSearch: payload
      };
    
    case ActionTypes.SetBAvailableSqFtMin:
      return {
        ...state,
        bAvailableSqFtMin: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetBAvailableSqFtMax:
      return {
        ...state,
        bAvailableSqFtMax: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetBAvailableAcresMin:
      return {
        ...state,
        bAvailableAcresMin: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetBAvailableAcresMax:
      return {
        ...state,
        bAvailableAcresMax: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetBBuildingTypes:
      return {
        ...state,
        bBuildingTypes: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bBuildingTypes), payload)
      };
    
    case ActionTypes.SetBSpecialtyFeatures:
      return {
        ...state,
        bSpecialtyFeatures: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bSpecialtyFeatures), payload)
      };
    
    case ActionTypes.SetBRailServed:
      return {
        ...state,
        bRailServed: payload 
      };
    
    case ActionTypes.SetBMultiTenant:
      return {
        ...state,
        bMultiTenant: payload 
      };
    
    case ActionTypes.SetBZoning:
      return {
        ...state,
        bZoning: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bZoning), payload)
      };
    
    case ActionTypes.SetBReviewStatus:
      return {
        ...state,
        bReviewStatus: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bReviewStatus), payload)
      };
    
    case ActionTypes.SetBSaleOrLease:
      return {
        ...state,
        bSaleOrLease: payload
      };
    
    case ActionTypes.SetBSortBy:
      return {
        ...state,
        bSortBy: payload
      };
    
    case ActionTypes.SetBStates:
      return {
        ...state,
        bStates: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bStates), payload)
      };

      
    case ActionTypes.SetBRegions:
       return {
         ...state,
         bRegions: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bRegions), payload)
       };
       
    case ActionTypes.SetBCounties:
      return {
        ...state,
        bCounties: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bCounties), payload)
      };
      
    case ActionTypes.SetBCities:
      return {
        ...state,
        bCities: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.bCities), payload)
      };
    // #endregion
    
    // #region Site Actions
    case ActionTypes.SetSKeywordSearch:
      return {
        ...state,
        sKeywordSearch: payload
      };
    
    // case ActionTypes.SetSAvailableSqFtMin:
    //   return {
    //     ...state,
    //     sAvailableSqFtMin: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
    //   };
    
    // case ActionTypes.SetSAvailableSqFtMax:
    //   return {
    //     ...state,
    //     sAvailableSqFtMax: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
    //   };

    case ActionTypes.SetSAvailableAcresMin:
      return {
        ...state,
        sAvailableAcresMin: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetSAvailableAcresMax:
      return {
        ...state,
        sAvailableAcresMax: typeof payload == "string" ? payload : payload.target.value.replace(/^0+/, '')
      };
    
    case ActionTypes.SetSSpecialtyFeatures:
      return {
        ...state,
        sSpecialtyFeatures: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sSpecialtyFeatures), payload)
      };
    
    case ActionTypes.SetSRailServed:
      return {
        ...state,
        sRailServed: payload 
      };
    
    case ActionTypes.SetSZoning:
      return {
        ...state,
        sZoning: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sZoning), payload)
      };
    
    case ActionTypes.SetSReviewStatus:
      return {
        ...state,
        sReviewStatus: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sReviewStatus), payload)
      };
    
    case ActionTypes.SetSSaleOrLease:
      return {
        ...state,
        sSaleOrLease: payload
      };
    
    case ActionTypes.SetSSiteCertified:
      return {
        ...state,
        sSiteCertified: payload
      };
    
    case ActionTypes.SetSSortBy:
      return {
        ...state,
        sSortBy: payload
      };
    
    case ActionTypes.SetSStates:
      return {
        ...state,
        sStates: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sStates), payload)
      };
      
    case ActionTypes.SetSRegions:
      return {
        ...state,
        sRegions: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sRegions), payload)
      };
    
    case ActionTypes.SetSCounties:
      return {
        ...state,
        sCounties: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sCounties), payload)
      };
      
    case ActionTypes.SetSCities:
      return {
        ...state,
        sCities: payload instanceof Set ? payload : updateSelectedOptions(new Set(state.sCities), payload)
      };

    case ActionTypes.SetRadiusCenterPoint:
      return {
        ...state,
        radiusCenterPoint: payload
      };
    // #endregion 
    default: 
    throw Error('Unknown action: ' + type);
  }

}